import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../mock/mock";
import { useContent } from "../context/ContentContext";

export default function ServicesGrid() {
  const { services = SERVICES } = useContent();
  return (
    <section className="relative py-24 lg:py-32 bg-[#0a0a0a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="divider-line" />
              <span className="text-[11px] tracking-[0.4em] text-[#B87333]">HİZMETLERİMİZ</span>
            </div>
            <h2 className="font-serif-display text-[#f5ede1] text-4xl md:text-5xl lg:text-6xl leading-tight font-light">
              Neler Yapıyoruz?
            </h2>
          </div>
          <Link
            to="/hizmetlerimiz"
            className="inline-flex items-center gap-3 text-[#B87333] text-[11px] tracking-[0.3em] hover:text-[#D4A574] transition-colors"
          >
            TÜM HİZMETLER <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, idx) => (
            <Link
              key={s.slug}
              to={`/hizmet/${s.slug}`}
              className="group relative border border-[#B87333]/20 bg-[#0d0b09] p-8 lg:p-10 overflow-hidden hover:border-[#B87333] transition-colors duration-500"
            >
              <div className="absolute top-6 right-6 text-[11px] tracking-[0.3em] text-[#B87333]/50 group-hover:text-[#B87333] transition-colors">
                {String(idx + 1).padStart(2, "0")}
              </div>
              <div className="min-h-[160px] flex flex-col justify-between">
                <h3 className="font-serif-display text-[#f5ede1] text-xl lg:text-2xl leading-snug mb-6 pr-8">
                  {s.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-[11px] tracking-[0.3em] text-[#a89a85] group-hover:text-[#B87333] transition-colors">
                    DETAY
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-[#B87333] transform transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </div>
              <div className="absolute inset-x-0 bottom-0 h-[2px] w-0 bg-[#B87333] group-hover:w-full transition-all duration-700" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
